import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import includes from 'lodash/includes';
import type { RootReduxState } from 'app/shared/flux/reducers/index';
import UserItemActions from 'app/shared/flux/actions/UserItemActions';
import AppActions from 'app/shared/flux/actions/AppActions';
import { emitTrackHideHomeFromHdpEvent } from 'app/shared/models/Clickstream/HdpClickstreamEvents';
import { ReportListingOverlay } from './ReportListingOverlay';
import * as styles from './listingFeedbackModule.styles';

export const ListingFeedbackModule = () => {
  const dispatch = useDispatch();
  const listing = useSelector((state: RootReduxState) => state.currentListingDetails?.currentListing);
  const isLoggedIn = useSelector((state: RootReduxState) => state.user.loggedIn);
  const [isReportOpen, setIsReportOpen] = useState(false);

  if (!listing) return null;

  const isListingHidden = listing.userItemTypes && includes(listing.userItemTypes, 'hidden');

  const handleHide = () => {
    if (!isLoggedIn) {
      dispatch(
        AppActions.showPopupModal('PromptLogin', {
          caption: 'Sign in to hide listings from your search results.',
          shouldNotRedirect: true,
        }),
      );
      return;
    }

    dispatch(UserItemActions.toggleUserItem('hidden', listing));
    emitTrackHideHomeFromHdpEvent();

    if (!isListingHidden) {
      dispatch(
        AppActions.toggleNotificationMessage({
          content: 'Listing hidden from your search results.',
        }),
      );
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.reportSection}>
        <span className={styles.reportHeading}>Spot something off?</span>
        <span className={styles.reportDescription}>Good catch. Flag it and help keep listings legit.</span>
        <div className={styles.actionRow}>
          <button type="button" className={styles.reportLink} onClick={() => setIsReportOpen(true)}>
            Report listing
          </button>
          <span className={styles.separator} aria-hidden="true">
            |
          </span>
          <button type="button" className={styles.reportLink} onClick={handleHide}>
            {isListingHidden ? 'Unhide listing' : 'Hide listing'}
          </button>
        </div>
      </div>

      <ReportListingOverlay open={isReportOpen} onOpenChange={setIsReportOpen} />
    </div>
  );
};
